const YT_ENDED = 0;
const YT_PLAYING = 1;
const YT_PAUSED = 2;
const YT_BUFFERING = 3;
const SLIDE_DELAY = 4500;

const heroSlider = document.querySelector(".hero-swiper");

const loadedVideo = (frame) => {
    if (!frame || !window.oi || !window.oi.loaded || !window.oi.loaded.video) {
        return null;
    }
    return window.oi.loaded.video[frame.id] || null;
};

const readyPlayer = (frame) => {
    const record = loadedVideo(frame);
    const player = record ? record.player : null;
    return player && typeof player.playVideo === "function" ? player : null;
};

const whenReady = (frame, callback) => {
    const player = readyPlayer(frame);

    if (player) {
        callback(player);
        return;
    }

    window.addEventListener(
        `oi.loaded.video.${frame.id}`,
        () => {
            const mounted = readyPlayer(frame);
            if (mounted) {
                callback(mounted);
            }
        },
        { once: true }
    );
};

const startYouTube = (player) => {
    player.mute();
    player.seekTo(0, true);
    player.playVideo();
    player.is_playing = true;
};

if (heroSlider) {
    const slides = heroSlider.querySelectorAll(".swiper-slide");

    if (slides.length > 1) {
        const heroSwiper = new Swiper(heroSlider, {
            autoplay: {
                delay: SLIDE_DELAY,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: ".hero-swiper-button-next",
                prevEl: ".hero-swiper-button-prev",
            },
            loop: true,
            effect: "fade",
            a11y: true,
            keyboard: true,
        });

        let currentMedia = null;
        let fallbackTimer = null;

        const getActiveMedia = () => {
            const slide = heroSwiper.slides[heroSwiper.activeIndex];
            return slide
                ? slide.querySelector("video, .oi-video-youtube iframe")
                : null;
        };

        const advance = () => {
            heroSwiper.slideNext();
            if (!getActiveMedia()) {
                heroSwiper.autoplay.start();
            }
        };

        const pauseMedia = (media) => {
            if (media.tagName === "VIDEO") {
                if (!media.paused) {
                    media.pause();
                }
                return;
            }

            const player = readyPlayer(media);
            if (player) {
                player.pauseVideo();
                player.is_playing = false;
            }
        };

        const playYouTube = (frame) => {
            whenReady(frame, (player) => {
                if (getActiveMedia() === frame) {
                    startYouTube(player);
                }
            });

            fallbackTimer = window.setTimeout(() => {
                if (getActiveMedia() !== frame) {
                    return;
                }
                const player = readyPlayer(frame);
                const state = player ? player.getPlayerState() : null;
                if (state !== YT_PLAYING && state !== YT_BUFFERING) {
                    advance();
                }
            }, SLIDE_DELAY);
        };

        const syncHeroMedia = () => {
            const activeMedia = getActiveMedia();

            if (activeMedia === currentMedia) {
                return;
            }

            currentMedia = activeMedia;
            window.clearTimeout(fallbackTimer);

            heroSlider
                .querySelectorAll("video, .oi-video-youtube iframe")
                .forEach((media) => {
                    if (media !== activeMedia) {
                        pauseMedia(media);
                    }
                });

            if (!activeMedia) {
                return;
            }

            heroSwiper.autoplay.stop();

            if (activeMedia.tagName === "VIDEO") {
                activeMedia.currentTime = 0;
                activeMedia.play().catch(() => heroSwiper.autoplay.start());
                return;
            }

            playYouTube(activeMedia);
        };

        heroSlider.addEventListener(
            "ended",
            (event) => {
                if (event.target === getActiveMedia()) {
                    advance();
                }
            },
            true
        );

        heroSlider
            .querySelectorAll(".oi-video-youtube iframe")
            .forEach((frame) => {
                whenReady(frame, (player) => {
                    player.addEventListener("onStateChange", (event) => {
                        if (getActiveMedia() !== frame) {
                            return;
                        }
                        if (event.data === YT_ENDED) {
                            advance();
                        } else if (event.data === YT_PLAYING) {
                            heroSwiper.autoplay.stop();
                        } else if (event.data === YT_PAUSED) {
                            heroSwiper.autoplay.start();
                        }
                    });
                });
            });

        heroSwiper.on("slideChange", syncHeroMedia);
        heroSwiper.on("loopFix", syncHeroMedia);
        syncHeroMedia();
    } else {
        const video = heroSlider.querySelector("video");
        const frame = heroSlider.querySelector(".oi-video-youtube iframe");

        if (video) {
            video.loop = true;
            video.play().catch(() => {});
        } else if (frame) {
            whenReady(frame, (player) => {
                startYouTube(player);
                player.addEventListener("onStateChange", (event) => {
                    if (event.data === YT_ENDED) {
                        startYouTube(player);
                    }
                });
            });
        }
    }
}
